import type { OptionsDocument, QuoteTerms } from 'paintscout'
import { template, createOptionsContext } from '../../../../templater'

export function getInvoiceTerms({
  options,
  quoteTerms
}: {
  options: OptionsDocument
  quoteTerms: QuoteTerms
}): QuoteTerms {
  const visibility = options?.options?.terms?.values?.invoice?.visibility ?? 'quote'
  switch (visibility) {
    case 'both': {
      const invoiceTerms = options.options?.terms?.values.invoice ?? quoteTerms
      const quoteTermsContent = quoteTerms?.content ?? ''
      return {
        name: 'invoice_terms',
        label: invoiceTerms.label,
        custom: false,
        content: template({
          text: invoiceTerms.content + '<p></p><hr /><p></p>' + quoteTermsContent,
          context: createOptionsContext({
            options
          })
        })
      }
    }
    case 'invoice': {
      const newTerms = options.options?.terms?.values.invoice ?? quoteTerms
      return {
        name: 'invoice_terms',
        label: newTerms.label,
        custom: false,
        content: template({
          text: newTerms.content,
          context: createOptionsContext({
            options
          })
        })
      }
    }
    default:
      return quoteTerms
  }
}
